import React from "react";
import Box from "@mui/material/Box";
import { SxProps, Theme } from '@mui/material/styles';

interface CustomContainerProps {
  children: React.ReactNode,
  sx?: SxProps<Theme>,
}

function CustomContainer({ children, sx }: CustomContainerProps) {
  return (
    <Box component={"div"} sx={{ width: '95%', mx: "auto", ...sx }}>
      {children}
    </Box>
  );
}

export default CustomContainer;
